import { calcTenancyLength } from 'common/helpers/day';
import formatPrice from '~helpers/currency';
import event from '~helpers/mixpanel';

export const handleCancelNewCounterOfferTrack = (counterOffer, record, t) => {
  const changeInfoLists = [];
  const CounterOfferRoomName = counterOffer?.unitTypeName;
  const CounterOfferRoomType = counterOffer?.unitTypeCategory;
  const originRoomType = record?.unitTypeCategory;
  const OriginRoomName = record?.unitTypeName;
  // property
  if (counterOffer.propertyId !== record.propertyId) {
    const changeInfo = {
      property: [record.propertyName, counterOffer.propertyName],
    };
    changeInfoLists.push(changeInfo);
  }
  if (CounterOfferRoomName !== OriginRoomName || CounterOfferRoomType !== originRoomType) {
    const changeInfo = {
      Room: [OriginRoomName, CounterOfferRoomName],
    };
    changeInfoLists.push(changeInfo);
  }

  //Move-in Date
  if (counterOffer.moveInDate !== record.moveInDate) {
    const changeInfo = {
      'Move-in Time': [record.moveInDate, counterOffer.moveInDate],
    };
    changeInfoLists.push(changeInfo);
  }
  // Move-out Date
  if (counterOffer.moveOutDate !== record.moveOutDate) {
    const changeInfo = {
      'Move-out Time,': [record.moveOutDate, counterOffer.moveOutDate],
    };
    changeInfoLists.push(changeInfo);
  }
  //Discount Type
  if (counterOffer?.discountType) {
    const changeInfo = {
      'Discount Type': [
        t(
          `landlord.long_tail.booking.counter_modal.form.discount_type.${counterOffer?.discountType.toLocaleLowerCase()}`,
        ),
        t('landlord.long_tail.booking.counter_modal.form.discount_type.no_discount'),
      ],
    };

    changeInfoLists.push(changeInfo);
  }
  // Discount Value
  if (counterOffer?.discountValue) {
    const changeInfo = {
      'Discount Value': [null, counterOffer?.discountValue],
    };
    changeInfoLists.push(changeInfo);
  }
  //Offer Validity Period
  if (counterOffer?.validPeriodHour && counterOffer?.validPeriodHour !== 24) {
    const changeInfo = {
      'Offer Validity Period': [24, counterOffer?.validPeriodHour],
    };
    changeInfoLists.push(changeInfo);
  }
  // Message
  if (counterOffer?.message) {
    const changeInfo = {
      Message: [null, counterOffer?.message],
    };
    changeInfoLists.push(changeInfo);
  }

  if (counterOffer?.totalPrice !== record?.totalPrice) {
    const newTotal = formatPrice(counterOffer?.totalPrice, counterOffer?.currency);
    const originTotal = formatPrice(record?.totalPrice, record?.currency);
    const changeInfo = {
      'Total Price': [originTotal, newTotal],
    };
    changeInfoLists.push(changeInfo);
  }
  //Tenancy
  if (
    counterOffer.moveInDate !== record.moveInDate ||
    counterOffer.moveOutDate !== record.moveOutDate
  ) {
    const newTancy = calcTenancyLength(t, counterOffer?.moveInDate, counterOffer?.moveOutDate);
    const oldTancy = calcTenancyLength(t, record?.moveInDate, record?.moveOutDate);
    const changeInfo = { Tenancy: [oldTancy, newTancy] };
    changeInfoLists.push(changeInfo);
  }

  event('Cancelled New Counter Offer', { 'Changed Info': changeInfoLists });
};

export const handleConfirmedCounterOfferTrack = (counterOffer, record, t) => {
  const changeInfoLists = [];
  const CounterOfferRoomName = counterOffer.unitTypeName;
  const CounterOfferRoomType = counterOffer.unitTypeCategory;
  const originRoomType = record.unitTypeCategory;
  const OriginRoomName = record.unitTypeName;
  if (CounterOfferRoomName !== OriginRoomName || CounterOfferRoomType !== originRoomType) {
    const changeInfo = {
      Room: [OriginRoomName, CounterOfferRoomName],
    };
    changeInfoLists.push(changeInfo);
  }
  // property
  if (counterOffer.propertyId !== record.propertyId) {
    const changeInfo = {
      property: [record.propertyName, counterOffer.propertyName],
    };
    changeInfoLists.push(changeInfo);
  }

  //Move-in Date
  if (counterOffer.moveInDate !== record.moveInDate) {
    const changeInfo = {
      'Move-in Time': [record.moveInDate, counterOffer.moveInDate],
    };
    changeInfoLists.push(changeInfo);
  }
  // Move-out Date
  if (counterOffer.moveOutDate !== record.moveOutDate) {
    const changeInfo = {
      'Move-out Time': [record.moveOutDate, counterOffer.moveOutDate],
    };
    changeInfoLists.push(changeInfo);
  }
  //Discount Type
  if (counterOffer?.discountType) {
    const changeInfo = {
      'Discount Type': [
        t(
          `landlord.long_tail.booking.counter_modal.form.discount_type.${counterOffer?.discountType.toLocaleLowerCase()}`,
        ),
        t('landlord.long_tail.booking.counter_modal.form.discount_type.no_discount'),
      ],
    };

    changeInfoLists.push(changeInfo);
  }
  //Tenancy
  if (
    counterOffer.moveInDate !== record.moveInDate ||
    counterOffer.moveOutDate !== record.moveOutDate
  ) {
    const newTancy = calcTenancyLength(t, counterOffer?.moveInDate, counterOffer?.moveOutDate);
    const oldTancy = calcTenancyLength(t, record?.moveInDate, record?.moveOutDate);
    const changeInfo = { Tenancy: [oldTancy, newTancy] };
    changeInfoLists.push(changeInfo);
  }
  // Discount Value
  if (counterOffer?.discountValue) {
    const changeInfo = {
      'Discount Value': [null, counterOffer?.discountValue],
    };
    changeInfoLists.push(changeInfo);
  }
  //Offer Validity Period
  if (counterOffer?.validPeriodHour && counterOffer?.validPeriodHour !== 24) {
    const changeInfo = {
      'Offer Validity Period': [24, counterOffer?.validPeriodHour],
    };
    changeInfoLists.push(changeInfo);
  }
  // Message
  if (counterOffer?.message) {
    const changeInfo = {
      Message: [null, counterOffer?.message],
    };
    changeInfoLists.push(changeInfo);
  }
  if (counterOffer?.totalPrice !== record?.totalPrice) {
    const newTotal = formatPrice(counterOffer?.totalPrice, counterOffer?.currency);
    const originTotal = formatPrice(record?.totalPrice, record?.currency);
    const changeInfo = {
      'Total Price': [originTotal, newTotal],
    };
    changeInfoLists.push(changeInfo);
  }

  event('Confirmed Counter Offer Settings', { 'Changed Info': changeInfoLists });
};
